import * as React from 'react';
import { CSSProperties } from 'react';
import { ShopCloseX } from './ShopCloseX';

const wrapperStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#a9a9a9A1',
    zIndex: 800
}
const popupStyle: CSSProperties = {
    zIndex: 900,
    position: 'fixed',
    background: 'white',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    width: '400px',
    transform: 'translate(-50%, -80%)',
    border: '6px solid black',
    padding: '35px'
}
const bannerStyle: CSSProperties = {
    fontSize: '24px',
    lineHeight: '55px',
    textAlign: 'center'
}
const messageStyle: CSSProperties = {
    fontSize: '18px',
    textAlign: 'center'
}
type Props = {
    email: string,
    clearStateCallback: (evt: any) => void
}

export class ShopConfirmation extends React.Component<Props, any>{

    render() {
        var email = this.props.email ?? "<missing email>";

        return (
            <div style={wrapperStyle} onClick={this.props.clearStateCallback}>
                <div style={popupStyle}>
                    <ShopCloseX closeAction={this.props.clearStateCallback} />
                    <div style={bannerStyle}>Success!</div>
                    <div style={messageStyle}>
                        Thank you for your order! A confirmation email has been sent to:
                        <br />
                        {email}
                        <br />
                        <br />
                        For any questions please contact us at sales@grafcow.com or call
                        <br />
                        (800) 472-3269
                    </div>
                </div>
            </div>
        )
    }
}

